import React from 'react';
import PropTypes from "prop-types";

export default function BarcodeTicketSVG(props) {
  return (
    <svg
      id={props.id}
      className={props.className}
      width={props.styles.width || "32px"}
      height={props.styles.height || "32px"}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Icon/Barcode</title>
      <g
        id="Icon/Barcode"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M2.56,20.28 L2.56,26.04 L8.32,26.04 L8.32,28.6 L0,28.6 L0,20.28 L2.56,20.28 Z M32,20.28 L32,28.6 L23.68,28.6 L23.68,26.04 L29.44,26.04 L29.44,20.28 L32,20.28 Z M13.44,8.12 L13.44,23.48 L10.88,23.48 L10.88,8.12 L13.44,8.12 Z M8.96,8.12 L8.96,23.48 L5.12,23.48 L5.12,8.12 L8.96,8.12 Z M26.88,8.12 L26.88,23.48 L24.32,23.48 L24.32,8.12 L26.88,8.12 Z M22.4,8.12 L22.4,23.48 L18.56,23.48 L18.56,8.12 L22.4,8.12 Z M16.64,8.12 L16.64,23.48 L15.36,23.48 L15.36,8.12 L16.64,8.12 Z M8.32,3 L8.32,5.56 L2.56,5.56 L2.56,11.32 L0,11.32 L0,3 L8.32,3 Z M32,3 L32,11.32 L29.44,11.32 L29.44,5.56 L23.68,5.56 L23.68,3 L32,3 Z"
          id="barcode_outline"
          fill={props.styles.fill || "#677383"}
        >
        </path>
      </g>
    </svg>
  );
}

BarcodeTicketSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};

BarcodeTicketSVG.defaultProps = {
  id: "",
  className: "",
  styles: {
    fill: "#677383",
    height: "32px",
    width: "32px"
  }
};
